// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"sound-mute"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M18.0002 21L9.99902 16.5V7.5L18.0002 3V21Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M6 16.5L6 7.5H9.99882L9.99882 16.5L6 16.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9.99882 16.5L6 16.5L6 7.5H9.99882M9.99882 16.5L18 21V3L9.99882 7.5M9.99882 16.5L9.99882 7.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SoundMuteIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sound-mute',
    ref,
    icon: element,
  },
));

SoundMuteIcon.displayName = 'SoundMuteIcon';

export default SoundMuteIcon;
